import { HTMLProps } from 'react';
import { IconElements } from '../../../config/icons';

export const SelectInput: React.FC<
    { selected: string | null; values: { value: string; label: string }[]; onChange: (value: string) => void } & Omit<
        HTMLProps<HTMLSpanElement>,
        'selected' | 'onChange'
    >
> = ({ values, selected, onChange, className, ...rest }) => {
    return (
        <span
            className={`relative flex flex-row items-center pl-4 py-0.5 border rounded-lg bg-white ${className}`}
            {...rest}
        >
            <select
                className="w-full px-0 py-1.5 pr-10 focus:outline-hidden appearance-none bg-white bg-opacity-0 cursor-pointer font-medium"
                value={selected || ''}
                onChange={(e) => onChange(e.target.value)}
            >
                {values.map(({ value, label }) => {
                    return (
                        <option value={value} key={value}>
                            {label}
                        </option>
                    );
                })}
            </select>
            <IconElements.ChevronDown className="absolute right-4 h-4 w-4 text-black pointer-events-none" />
        </span>
    );
};
